var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#627EEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2751 13.9093L31.0262 14.7339V38.6592L31.2751 38.9014L42.6607 32.3367L31.2751 13.9093Z",
    fill: "#C1CCF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.273 13.9093L19.8872 32.3367L31.273 38.9014V27.2887V13.9093Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2759 41.0018L31.1356 41.1686V49.6912L31.2759 50.0906L42.6684 34.4405L31.2759 41.0018Z",
    fill: "#C1CCF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.273 50.0906V41.0018L19.8872 34.4405L31.273 50.0906Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2708 38.9022L42.6564 32.3375L31.2708 27.2895V38.9022Z",
    fill: "#8198EE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8872 32.3376L31.273 38.9022V27.2896L19.8872 32.3376Z",
    fill: "#C1CCF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/ETH.6af0f149079c935183518ce21d9e1b61.svg";
export { ForwardRef as ReactComponent };